import React from 'react';
import { originalPrice } from './styles.mod.scss';

function PriceDisplay({ product = {} }) {
  const { priceDisplay, regularPriceDisplay } = product;
  const showOriginalPrice =
    regularPriceDisplay && regularPriceDisplay !== priceDisplay;

  return (
    <span>
      {priceDisplay && <span> |</span>}
      {showOriginalPrice && (
        <span>
          {' '}
          <span className={originalPrice}>${regularPriceDisplay}</span>
        </span>
      )}
      {priceDisplay && <span> ${priceDisplay}</span>}
    </span>
  );
}

export default PriceDisplay;
